import { useMutation, MutationResult } from '@apollo/client';
import { ExecutionResult } from 'graphql';
import {
  ConnectFitnessMutationVariables,
  ConnectFitnessMutation,
  PageType,
} from '../../../types/__generated__';
import { useCallback } from 'react';
import mutation from './queries/connectFitness.gql';
import getFitnessSettingsQuery from '../../components/StravaSettingsModals/StravaSettingsModal/stravaSettings.gql';
import { useNotNullableContext } from '../useNotNullableContext';
import { PageMetaContext } from '../../context';

export default function useConnectFitness({
  code,
  scope,
}: any): [
  () => Promise<ExecutionResult<ConnectFitnessMutation>>,
  MutationResult<ConnectFitnessMutation>,
] {
  const { pageShortName, pageType } = useNotNullableContext(PageMetaContext);

  const [runMutation, mutationResult] = useMutation<
    ConnectFitnessMutation,
    ConnectFitnessMutationVariables
  >(mutation, {
    context: {
      credentials: 'include',
    },
    refetchQueries: [
      {
        query: getFitnessSettingsQuery,
        variables: {
          type: pageType.toUpperCase() as PageType,
          slug: pageShortName,
        },
        context: {
          credentials: 'include',
        },
      },
    ],
  });

  return [
    useCallback(
      () =>
        runMutation({
          variables: {
            input: {
              code,
              scope,
            },
          },
        }),
      [runMutation, code, scope],
    ),
    mutationResult,
  ];
}
